import { rendererDiscountAndOrTaxes } from './rendererDiscountAndOrTaxes';
import { rendererTemplateIvan } from './rendererTemplateIvan';
import { rendererDefaultFactory } from './rendererDefaultFactory';

export function renderChipsFactory(viewField, engineApi) {
  if (typeof viewField.metadata.template === 'object') {
    return rendererDiscountAndOrTaxes(viewField, engineApi);
  }
  if (typeof viewField.metadata.template === 'string') {
    return rendererTemplateIvan(viewField, engineApi);
  }

  return rendererDefaultFactory(engineApi.register.toString(viewField, engineApi));
}
